import { ReactNode } from "react";
import { Box } from "@mui/material";
import styled from "@emotion/styled";
import { makeStyles } from "@mui/styles";
import TextContainer from "../../components/Texts/TextContainer";
import { AppbarTopic } from "../../components/Texts/styles";

const CustomContainer = styled(Box)({
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
});
const CustomBox = styled(Box)({
    padding: "2rem",
    borderRadius: "15px",
    width: "35%",
    maxWidth: "40%",
    minWidth: "15rem",
    minHeight: "60vh",
    transition: "all .3s",
    maxHeight: "75vh",
    height: "75vh",
    gap: "2rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
});
const Header = styled(Box)({
    display: "flex",
    flexDirection: "column",
    gap: ".7rem",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
});
type props = {
    children: ReactNode;
    text?: ReactNode;
    style?: any;
};
const useStyles = makeStyles((theme: any) => ({
    animatedItem: {
        animation: `$myEffect .6s ${theme.transitions.easing.easeInOut}`,
    },
    "@keyframes myEffect": {
        "0%": {
            transform: "scale(.99) translateY(-10px)",
        },
        "100%": {
            transform: "scale(1) translate(0)",
        },
    },
}));

export default function Frame({ children, text, style }: props) {
    const classes = useStyles();
    return (
        <CustomContainer bgcolor="primary.main">
            <CustomBox
                className={classes.animatedItem}
                sx={{ bgcolor: "primary.light", ...style }}
                boxShadow={1}
            >
                <Header>
                    <img
                        src={require('../../assets/images/Logo1.png')}
                        alt="logo"
                        loading="lazy"
                        style={{
                            minWidth: "3rem",
                            maxWidth: "4rem",
                            minHeight: "3rem",
                            maxHeight: "4rem",
                        }}
                        width="100%"
                        height="100%"
                    />
                    <TextContainer {...AppbarTopic} color="secondary.main"> YAADIN.COM</TextContainer>
                    <TextContainer flexWrap="wrap" fontSize="1.5rem" color="divider" width="100%">
                        {text}
                    </TextContainer>
                </Header>
                {children}
            </CustomBox>
        </CustomContainer>
    );
}
